<template>
			<div id="page-content" class="admin-sidebar">
				<div class="component-padding">
				
					<button class="button-type-f text-left" type="button">Export Spreadsheet</button>
					
					<div id="products-admin-options">
						<h1>Supplier Products</h1>
						<div>
							<input type="text" placeholder="Search Product">
							<select name="fabrianne">
								<option value="">All Suppliers</option>
								<option value="">Phelix Systems</option>
								<option value="">Fabrianne Inc</option>
								<option value="">Ast Corps</option>
							</select>
							<select name="francis">
								<option value="">Sort By</option>
								<option value="">Product Code</option>
								<option value="">Price</option>
							</select>
						</div>
					</div>
					
					<table class="admin-table">
							<tr>
								<th>Item</th>
								<th>Company</th> 
								<th>Product Code</th>
								<th>Price</th>
								<th>Currency</th>
								<th>Options</th>
							</tr>
							<tr v-for="n in 14">
								<td class="admin-table-row-image">
									<img src="static/images/j.jpeg" />
								</td>
								<td>Phelix Systems</td> 
								<td>6SGHA14</td>
								<td>140.00</td>
								<td>PHP</td>
								<td class="admin-table-row-options">
									<button>Edit Item</button>
									<button>Delete Item</button>
								</td>
							</tr>
					</table>
					
					<button class="button-type-f text-left" type="button">Export Spreadsheet</button>
				</div>
			</div>
</template>

<script>
	export default{
		data(){
			return{

			}
		},
		mounted(){
			relativeTo('nav', this.$el);
		}
	}
</script>


// WEBPACK FOOTER //
// AdminSupplierItems.vue?248b9467